module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"targetData":"Target data","event":"Event","coordinationParameter":"Coordination parameters"},"ja":{"targetData":"計測対象データ","event":"イベント","coordinationParameter":"連携元パラメータ"},"zh-hant":{"targetData":"測量目標數據","event":"事件","coordinationParameter":"連帶參數"},"zh-hans":{"targetData":"测量目标数据","event":"事件","coordinationParameter":"连带参数"}}')
  delete Component.options._Ctor
}
